import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import theme from "themes/theme";

import * as Sentry from "@sentry/react";

import App from "./features/App";
import { GlobalStyle, shouldForwardProp } from "./global-styles/global-style";
import reportWebVitals from "./reportWebVitals";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.5,
  enabled: process.env.NODE_ENV !== "development",
  beforeSend(event) {
    if (
      event.message?.includes("booking is not found or no longer active") ||
      event.message?.includes("booking with such PNR and surname was not found")
    ) {
      // filter out
      return null;
    }
    return event;
  },
  // For details of the ignoreErrors and denyUrls options see
  // https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
  ignoreErrors: [
    "top.GLOBALS",
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    "fb_xd_fragment",
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    "conduitPage",
    "Script error.",
    // filter out - attempt #1, didnt work, but keep for now
    "booking is not found or no longer active",
    "booking with such PNR and surname was not found",
  ],
  denyUrls: [
    /webview-demo\.zamna\.com/i,
    /webview-dev\.zamna\.com/i,
    /webview-dev-regula\.zamna\.com/i,
    /graph\.facebook\.com/i,
    /connect\.facebook\.net\/en_US\/all\.js/i,
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    /extensions\//i,
    /^chrome:\/\//i,
    /127\.0\.0\.1:4001\/isrunning/i,
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <GlobalStyle />
        <App />
      </StyleSheetManager>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
